export const removeComa = (value) => {
    return value.replace(',', '');
}

export const formatLocalToDate = (dateString) => {
    const date = new Date(dateString);
    const month = date.getMonth() + 1; // Add 1 to get month in 1-12 format
    const day = date.getDate();
    const year = date.getFullYear();
    // return `${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}/${year}`;
    return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
}

export const formatDateToLocal = (dateString) => {
    const [year, month, day] = dateString.split('-');
    const date = new Date(year, month - 1, day);
    const monthName = date.toLocaleString('default', { month: 'long' });
    return `${monthName} ${day}, ${year}`;
}

export const thousandSeparator = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}